import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavService, Menu } from '../../services/nav.service';
import { ApiService } from '../../services/api.service';
import * as _ from "lodash";
import { retry } from 'rxjs/operators';
import { AuthenticationService } from '../../../auth/authentication.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from '../../services/common.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {
    imagePath: any;
    currentUser: any;
    public menuItems: Menu[];
    public url: any;
    public fileurl: any;

    constructor(private router: Router,
        public navServices: NavService,
        private apiService: ApiService,
        private authenticationService: AuthenticationService,
        private _sanitizer: DomSanitizer,
        private commonService: CommonService) {

        this.imagePath = "scripts/libs/assets/images/user/user.png";

        this.currentUser = this.authenticationService.User;

        //this.apiService.get("Api/User/Config/", {}).subscribe((res: any) => {

        this.navServices.items.subscribe(menuItems => {

            var tempItems: Menu[] = [];

            this.authenticationService.currentUserConfig.subscribe(config => {
                if (config != null) {
                    menuItems.filter(item => {

                        var parentMenu = this.setMenuItems(tempItems, item, config.privileges);

                        if (!parentMenu || !item.children) return false

                        item.children.filter(subItem => {
                            var subParentMenu = this.setMenuItems(parentMenu.children, subItem, config.privileges);

                            if (!subParentMenu || !subItem.children) return false

                            subItem.children.filter(subSubItem => {
                                this.setMenuItems(subParentMenu.children, subSubItem, config.privileges);
                            })
                        })

                        //if there is only one child menu with same access as parent menu then remove the child menu
                        if (tempItems.length > 1 &&
                            tempItems[tempItems.length - 1].children &&
                            tempItems[tempItems.length - 1].children.length == 1 &&
                            item.accessarea == tempItems[tempItems.length - 1].children[0].accessarea) {
                            tempItems[tempItems.length - 1].type = "link";
                            tempItems[tempItems.length - 1].children.pop();
                        }

                    });
                }
            });

            this.menuItems = tempItems;

            this.router.events.subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    menuItems.filter(items => {
                        if (items.path === event.url)
                            this.setNavActive(items)
                        if (!items.children) return false
                        items.children.filter(subItems => {
                            if (subItems.path === event.url)
                                this.setNavActive(subItems)
                            if (!subItems.children) return false
                            subItems.children.filter(subSubItems => {
                                if (subSubItems.path === event.url)
                                    this.setNavActive(subSubItems)
                            })
                        })
                    })
                }
            })

        });

        //});
    }

    setMenuItems(menuItems: Menu[], item: Menu, privileges: any) {

        var requiredAccessAreaCodes;
        if (item.accessarea) requiredAccessAreaCodes = item.accessarea.split(','); //multiple access area 

        if (privileges && requiredAccessAreaCodes) {
            for (var i = 0; i < requiredAccessAreaCodes.length; i++) { //123:SWR,124:WR,125:R,126
                var tempAccess = requiredAccessAreaCodes[i].split(':');//123:SWR

                var requiredAccessArea = tempAccess[0];//123
                var requiredAccessType = tempAccess.length > 1 ? tempAccess[1] : 'R'; //SWR or default R

                var assignedAccessType = privileges[requiredAccessArea]; //assigned privilege for example either S or W or R
                if (assignedAccessType && requiredAccessType.indexOf(assignedAccessType) >= 0) {
                    var menu: Menu = _.cloneDeep(item);
                    menu.children = [];
                    menuItems.push(menu);
                    return menu;
                }
            }
        }
    }

    // Active Nave state
    setNavActive(item) {
        this.menuItems.filter(menuItem => {
            if (menuItem != item)
                menuItem.active = false
            if (menuItem.children && menuItem.children.includes(item))
                menuItem.active = true
            if (menuItem.children) {
                menuItem.children.filter(submenuItems => {
                    if (submenuItems.children && submenuItems.children.includes(item)) {
                        menuItem.active = true
                        submenuItems.active = true
                    }
                })
            }
        })
    }

    // Click Toggle menu
    toggletNavActive(item) {
        this.commonService.clearData();
        if (!item.active) {
            this.menuItems.forEach(a => {
                if (this.menuItems.includes(item))
                    a.active = false
                if (!a.children) return false
                a.children.forEach(b => {
                    if (a.children.includes(item)) {
                        b.active = false
                    }
                })
            });
        }
        item.active = !item.active
    }

    home() {
        this.commonService.clearData();
        this.router.navigate(["App/DxRoot"]);
    }

    //Fileupload
    readUrl(event: any) {
        if (event.target.files.length === 0)
            return;
        //Image upload validation
        var mimeType = event.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            return;
        }
        // Image upload
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
            this.imagePath = reader.result;
        }
    }

}
